import { render, staticRenderFns } from "./Page01.vue?vue&type=template&id=5fdda858&scoped=true&"
import script from "./Page01.vue?vue&type=script&lang=js&"
export * from "./Page01.vue?vue&type=script&lang=js&"
import style0 from "./Page01.vue?vue&type=style&index=0&id=5fdda858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdda858",
  null
  
)

export default component.exports